import React from "react";
import moment from "moment";
import { FormSection, Field, TextAreaField, employeeLabel } from "../FormBits";

/*
GET /ticket/{id}/ already carries diagnostic_report[]/repair_report[]/
quality_check_report[] - backend confirmed (2026-09-25) this isn't a gap,
just unrendered so far. Entries are empty until a technician actually works
the ticket through diagnostic-reports/repair-reports/quality-check, so an
empty array here means "not reached that step yet", not missing data.
*/

const formatDate = function (value) {
  const when = value ? moment(value) : null;
  return when && when.isValid() ? when.format("DD MMM YYYY · HH:mm") : undefined;
};

const formatChoice = function (value) {
  if (!value) return undefined;
  return String(value)
    .split("_")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

const ReportEntry = function (props) {
  return (
    <div className="tn-report-entry">
      {props.index > 0 ? <div className="tn-brief-divider" /> : null}
      {props.children}
    </div>
  );
};

export const DiagnosticEntry = function (props) {
  const entry = props.entry;
  const accessories = entry.accessories || [];
  const accessoryText = accessories
    .map(function (item) {
      return item.accessory + " × " + item.quantity;
    })
    .join(", ");

  return (
    <ReportEntry index={props.index}>
      <div className="tn-fieldgrid tn-fieldgrid-3">
        <Field label="Technician" value={employeeLabel(entry.technician)} />
        <Field label="Received Items" value={entry.received_items} />
        <Field label="Logged" value={formatDate(entry.created)} />
      </div>
      <TextAreaField label="Summary of Issue" value={entry.summary_of_issue} />
      {accessories.length ? (
        <Field label="Accessories" value={accessoryText} />
      ) : null}
    </ReportEntry>
  );
};

export const RepairEntry = function (props) {
  const entry = props.entry;
  const parts = entry.repair_parts || [];
  const partsText = parts
    .map(function (item) {
      return (
        item.inventory + " × " + item.quantity + (item.is_repurposed ? " (repurposed)" : "")
      );
    })
    .join(", ");

  return (
    <ReportEntry index={props.index}>
      <div className="tn-fieldgrid tn-fieldgrid-3">
        <Field label="Technician" value={employeeLabel(entry.technician)} />
        <Field label="Repair Level" value={formatChoice(entry.repair_level)} />
        <Field label="Logged" value={formatDate(entry.created)} />
      </div>
      <TextAreaField label="Repair Details" value={entry.repair_details} />
      {parts.length ? <Field label="Parts Used" value={partsText} /> : null}
    </ReportEntry>
  );
};

export const QualityCheckEntry = function (props) {
  const entry = props.entry;
  const videos = entry.videos || [];

  return (
    <ReportEntry index={props.index}>
      <div className="tn-fieldgrid tn-fieldgrid-2">
        <Field label="Technician" value={employeeLabel(entry.technician)} />
        <Field label="Logged" value={formatDate(entry.created)} />
      </div>
      <TextAreaField label="Check Detail" value={entry.check_detail} />
      {videos.length ? (
        <ul className="tn-filelist">
          {videos.map(function (video, index) {
            return (
              <li className="tn-filelist-item" key={index}>
                <a href={video.video} target="_blank" rel="noreferrer">
                  Video {index + 1}
                </a>
              </li>
            );
          })}
        </ul>
      ) : null}
    </ReportEntry>
  );
};

const ReportTab = function (props) {
  const ticket = props.ticket || {};
  const diagnosticReports = ticket.diagnostic_report || [];
  const repairReports = ticket.repair_report || [];
  const qualityCheckReports = ticket.quality_check_report || [];

  return (
    <div className="tn-tabpanel">
      <FormSection title="Diagnostic Report">
        {diagnosticReports.length ? (
          diagnosticReports.map(function (entry, index) {
            return <DiagnosticEntry key={entry.id || index} entry={entry} index={index} />;
          })
        ) : (
          <div className="tn-empty">No diagnostic report yet.</div>
        )}
      </FormSection>

      <FormSection title="Repair Report">
        {repairReports.length ? (
          repairReports.map(function (entry, index) {
            return <RepairEntry key={entry.id || index} entry={entry} index={index} />;
          })
        ) : (
          <div className="tn-empty">No repair report yet.</div>
        )}
      </FormSection>

      <FormSection title="Quality Check Report">
        {qualityCheckReports.length ? (
          qualityCheckReports.map(function (entry, index) {
            return <QualityCheckEntry key={entry.id || index} entry={entry} index={index} />;
          })
        ) : (
          <div className="tn-empty">No quality check report yet.</div>
        )}
      </FormSection>
    </div>
  );
};

export default ReportTab;
